/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useSnackbar } from "notistack";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { format } from "date-fns";
import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useMaterialUIController } from "context";
import Loader from "components/custom/Loader";
import useApiRequest from "utils/Apirequest";
import { convertUTCtoDubai } from "utils/Constant";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
  Box,
  Typography,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import PersonIcon from "@mui/icons-material/Person";
import DescriptionIcon from "@mui/icons-material/Description";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { CellWifi } from "@mui/icons-material";
import BoltIcon from "@mui/icons-material/Bolt";
import CategoryIcon from "@mui/icons-material/Category";
import LabelIcon from "@mui/icons-material/Label";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PublicIcon from "@mui/icons-material/Public";
import DevicesIcon from "@mui/icons-material/Devices";


dayjs.extend(utc);
dayjs.extend(timezone);

const { RangePicker } = DatePicker;

function AuditLogs() {
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const [isTableLoading, setIsTableLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const apiRequest = useApiRequest();

  // Filters
  const [actionFilter, setActionFilter] = useState("");
  const [entityTypeFilter, setEntityTypeFilter] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);

  // Pagination
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  // Detail Modal
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const formatChangeValue = (field, value) => {
    if (value === null || value === undefined) return "—";
    // if (field.toLowerCase().includes("password")) return "••••••••••";
    return JSON.stringify(value);
  };

  const InfoCard = ({ icon, label, value }) => (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        px: 2,
        py: 1.75,
        borderRadius: 2,
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        height: "100%",
        alignItems: "center",
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: "10px",
          background:
            "linear-gradient(135deg, #ff1744 0%, #ff5252 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>

      {/* Text */}
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "0.72rem",
            color: "text.secondary",
            lineHeight: 1.2,
          }}
        >
          {label}
        </Typography>

        <Typography
          sx={{
            fontSize: "0.9rem",
            fontWeight: 500,
            color: "text.primary",
            wordBreak: "break-word",
          }}
        >
          {value || "N/A"}
        </Typography>
      </Box>
    </Box>
  );
  const actionPillSx = (action) => ({
    height: 20,
    minWidth: 150,
    borderRadius: "6px",
    fontSize: "0.6rem",
    fontWeight: 600,
    textTransform: "uppercase",
    justifyContent: "center",
    px: 0,
    letterSpacing: "0.3px",

    "& .MuiChip-label": {
      px: 1,
      py: 0,
      width: "100%",
      textAlign: "center",
    },

    backgroundColor: action?.includes("created")
      ? "#e8f5e9"
      : action?.includes("updated")
        ? "#e3f2fd"
        : action?.includes("deleted")
          ? "#ffebee"
          : "#eeeeee",

    color: action?.includes("created")
      ? "#2e7d32"
      : action?.includes("updated")
        ? "#1565c0"
        : action?.includes("deleted")
          ? "#c62828"
          : "#616161",
  });


  // Action options
  const actionOptions = [
    { value: "", label: "All Actions" },
    { value: "created", label: "Created" },
    { value: "updated", label: "Updated" },
    { value: "deleted", label: "Deleted" },
  ];

  // Entity type options
  const entityTypeOptions = [
    { value: "", label: "All Entity Types" },
    { value: "notification_config", label: "Notification Config" },
    { value: "notification_interval", label: "Notification Interval" },
    { value: "charger", label: "Charger" },
    { value: "location", label: "Location" },
    { value: "driver", label: "Driver" },
    { value: "vehicle", label: "Vehicle" },
    { value: "user", label: "User" },
    { value: "supervisor", label: "Supervisor" },
    { value: "manager", label: "Manager" },
  ];
  const centerAlign = {
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        textAlign: "center",
        whiteSpace: "normal",
        lineHeight: 1.3,
        fontWeight: "bold",
      },
    },
    muiTableBodyCellProps: {
      align: "center",
      sx: { textAlign: "center" },
    },
  };

  const columns = [
    {
      accessorKey: "createdAt",
      header: "Date & Time",
      ...centerAlign,

      size: 220,
      Cell: ({ cell }) => (
        <MDTypography variant="caption" fontWeight="medium">
          {convertUTCtoDubai(cell.getValue())}
        </MDTypography>
      ),
    },
    {
      accessorKey: "action",
      header: "Action",
      ...centerAlign,
      size: 200,
      Cell: ({ cell }) => {
        const action = cell.getValue();

        if (!action) {
          return (
            <Chip
              label="N/A"
              size="small"
              sx={actionPillSx("default")}
            />
          );
        }

        return (
          <Chip
            label={action.replace(/_/g, " ").toUpperCase()}
            size="small"
            sx={actionPillSx(action)}
          />
        );
      },
    }
    ,
    {
      accessorKey: "entityType",
      header: "Entity Type",
      ...centerAlign,
      size: 250,
      Cell: ({ cell }) => (
        <MDTypography variant="caption" fontWeight="medium">
          {cell.getValue().replace(/_/g, " ").toUpperCase()}
        </MDTypography>
      ),
    },
    {
      accessorKey: "entityName",
      header: "Entity Name",
      ...centerAlign,
      size: 250,
      Cell: ({ cell }) => (
        <MDTypography variant="caption" fontWeight="regular">
          {cell.getValue() || "N/A"}
        </MDTypography>
      ),
    },
    {
      accessorKey: "changedBy.userName",
      header: "Changed By",
      ...centerAlign,
      size: 250,
      Cell: ({ cell, row }) => (
        <MDBox
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          gap={0.75}
        >
          <PersonIcon fontSize="small" color="action" />
          <MDTypography variant="caption" fontWeight="medium">
            {cell.getValue() || "Unknown"}
          </MDTypography>
        </MDBox>
      ),
    },
    {
      accessorKey: "changedBy.userEmail",
      header: "User Email",
      ...centerAlign,
      size: 220,
      Cell: ({ cell }) => (
        <MDTypography variant="caption" fontWeight="regular" color="text">
          {cell.getValue() || "N/A"}
        </MDTypography>
      ),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      ...centerAlign,
      size: 200,
      enableSorting: false,
      Cell: ({ row }) => (
        <MDButton
          variant="outlined"
          color={sidenavColor}
          size="small"
          onClick={() => handleViewDetails(row.original)}
          startIcon={<DescriptionIcon />}
        >
          Details
        </MDButton>
      ),
    },
  ];


  const fetchAuditLogs = async () => {
    setIsTableLoading(true);
    try {
      const params = {
        limit: pagination.pageSize,
        skip: pagination.pageIndex * pagination.pageSize,
      };

      if (actionFilter) {
        // Convert action filter to full action name (e.g., "created" -> matches any action containing "created")
        params.action = actionFilter;
      }
      if (entityTypeFilter) params.entityType = entityTypeFilter;
      if (dateRange[0] && dateRange[1]) {
        params.startDate = dateRange[0].toISOString();
        params.endDate = dateRange[1].toISOString();
      }

      const { data, error } = await apiRequest("GET", "/audit-logs", null, params, {}, false, false);

      if (data?.success) {
        setRows(data.logs || []);
        setTotalCount(data.total || 0);
      } else {
        enqueueSnackbar(error?.message || data?.message || "Failed to fetch audit logs", {
          variant: "error",
        });
      }
    } catch (error) {
      console.error("Error fetching audit logs:", error);
      enqueueSnackbar("Error fetching audit logs", { variant: "error" });
    } finally {
      setIsTableLoading(false);
    }
  };

  useEffect(() => {
    fetchAuditLogs();
  }, [pagination, actionFilter, entityTypeFilter, dateRange]);

  const handleViewDetails = (log) => {
    setSelectedLog(log);
    setIsDetailModalOpen(true);
  };

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
    setSelectedLog(null);
  };

  const handleResetFilters = () => {
    setActionFilter("");
    setEntityTypeFilter("");
    setDateRange([null, null]);
    setPagination({ pageIndex: 0, pageSize: 20 });
  };


  const maskSensitiveFields = (obj) => {
    if (!obj || typeof obj !== "object") return obj;
  
    const cloned = Array.isArray(obj) ? [] : {};
  
    for (const key in obj) {
      if (key.toLowerCase().includes("password")) {
        cloned[key] = "*****";
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        cloned[key] = maskSensitiveFields(obj[key]);
      } else {
        cloned[key] = obj[key];
      }
    }
  
    return cloned;
  };
  

  const renderChangeDetails = (changes) => {
    if (!changes) {
      return (
        <Typography sx={{ fontSize: "0.8rem", color: "text.secondary" }}>
          No changes recorded
        </Typography>
      );
    }

    return (
      <Box>
        {/* FIELD LEVEL CHANGES */}
        {changes.fields?.length > 0 && (
          <Box mb={2}>
            <Typography
              sx={{
                fontSize: "0.75rem",
                fontWeight: 600,
                mb: 1,
                color: "text.secondary",
              }}
            >
              Field Changes
            </Typography>

            {changes.fields.map((field, index) => (
              <Box
                key={index}
                sx={{
                  mb: 1,
                  p: 1.5,
                  borderRadius: 1.5,
                  backgroundColor: "#f9fafb",
                  border: "1px solid #eee",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    mb: 0.75,
                  }}
                >
                  {field.field}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    color: "error.main",
                    fontFamily: "monospace",
                    mb: 0.25,
                  }}
                >
                  Old: {formatChangeValue(field.field, field.oldValue)}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    color: "success.main",
                    fontFamily: "monospace",
                  }}
                >
                  New: {formatChangeValue(field.field, field.newValue)}
                </Typography>
              </Box>
            ))}
          </Box>
        )}

        {/* BEFORE SNAPSHOT */}
        {changes.before && (
          <Box mb={2}>
            <Typography
              sx={{
                fontSize: "0.75rem",
                fontWeight: 600,
                mb: 0.75,
                color: "text.secondary",
              }}
            >
              Before
            </Typography>

            <Box
              component="pre"
              sx={{
                p: 1.5,
                borderRadius: 1.5,
                backgroundColor: "#f5f7fa",
                fontSize: "0.7rem",
                fontFamily: "monospace",
                overflow: "auto",
                maxHeight: 320,
              }}
            >
              {JSON.stringify(maskSensitiveFields(changes.before), null, 2)}
            </Box>
          </Box>
        )}

        {/* AFTER SNAPSHOT */}
        {changes.after && (
          <Box>
            <Typography
              sx={{
                fontSize: "0.75rem",
                fontWeight: 600,
                mb: 0.75,
                color: "text.secondary",
              }}
            >
              After
            </Typography>

            <Box
              component="pre"
              sx={{
                p: 1.5,
                borderRadius: 1.5,
                backgroundColor: "#f5f7fa",
                fontSize: "0.7rem",
                fontFamily: "monospace",
                overflow: "auto",
                maxHeight: 320,
              }}
            >
              {JSON.stringify(maskSensitiveFields(changes.after), null, 2)}
            </Box>
          </Box>
        )}
      </Box>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  <HistoryIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                  Audit Logs
                </MDTypography>
                <MDButton
                  variant="outlined"
                  color="white"
                  size="small"
                  onClick={handleResetFilters}
                >
                  Reset Filters
                </MDButton>
              </MDBox>

              {/* Filters */}
              <MDBox p={3}>
                <Grid container spacing={2} mb={3}>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Action</InputLabel>
                      <Select
                        value={actionFilter}
                        label="Action"
                        onChange={(e) => setActionFilter(e.target.value)}
                      >
                        {actionOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Entity Type</InputLabel>
                      <Select
                        value={entityTypeFilter}
                        label="Entity Type"
                        onChange={(e) => setEntityTypeFilter(e.target.value)}
                      >
                        {entityTypeOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <RangePicker
                      style={{ width: "100%" }}
                      value={dateRange}
                      onChange={(dates) => setDateRange(dates || [null, null])}
                      format="YYYY-MM-DD"
                      placeholder={["Start Date", "End Date"]}
                    />
                  </Grid>
                </Grid>

                {/* Table */}
                {isTableLoading ? (
                  <Loader />
                ) : (
                  <CustomMaterialTablePage
                    columns={columns}
                    data={rows}
                    manualPagination
                    rowCount={totalCount}
                    page={pagination.pageIndex}
                    pagesize={pagination.pageSize}
                    paginationChange={(updater) => {
                      setPagination((prev) => {
                        const next =
                          typeof updater === "function"
                            ? updater(prev)
                            : updater;

                        return {
                          pageIndex: next.pageIndex ?? prev.pageIndex,
                          pageSize: next.pageSize ?? prev.pageSize,
                        };
                      });
                    }}

                    enableRowSelection={false}
                    enableColumnFilters={false}
                    enableGlobalFilter={false}
                    muiTableBodyCellProps={{
                      sx: { px: 1, py: 0.75 },
                    }}
                    muiTableHeadCellProps={{
                      sx: { px: 1, py: 1 },
                    }}
                  />


                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Detail Modal */}
      <Dialog
        open={isDetailModalOpen}
        onClose={handleCloseDetailModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            backgroundColor: "#fafafa",
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "12px",
                background:
                  "linear-gradient(135deg, #ff1744 0%, #ff5252 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <HistoryIcon sx={{ color: "#fff" }} />
            </Box>
            <Box>
              <Typography variant="h6" fontWeight={600}>
                Audit Log Details
              </Typography>
              <Typography variant="caption" color="text.secondary">
                View activity information
              </Typography>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pt: 1.5, pb: 2 }}>
          {selectedLog && (
            <Grid container spacing={1.5}>
              <Grid item xs={12} md={6}>
                <InfoCard
                  icon={<BoltIcon />}
                  label="Action"
                  value={
                    <Chip
                      label={selectedLog.action.replace(/_/g, " ").toUpperCase()}
                      size="small"
                      sx={{
                        height: 20,
                        fontSize: "0.6rem",
                        fontWeight: 600,
                        px: 0.75,
                        borderRadius: "6px",
                        lineHeight: 1,
                        backgroundColor:
                          selectedLog.action.includes("created")
                            ? "#e8f5e9"
                            : selectedLog.action.includes("updated")
                              ? "#e3f2fd"
                              : "#ffebee",
                        color:
                          selectedLog.action.includes("created")
                            ? "#2e7d32"
                            : selectedLog.action.includes("updated")
                              ? "#1565c0"
                              : "#c62828",
                      }}
                    />

                  }
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InfoCard
                  icon={<CategoryIcon />}
                  label="Entity Type"
                  value={selectedLog.entityType.replace(/_/g, " ").toUpperCase()}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InfoCard
                  icon={<LabelIcon />}
                  label="Entity Name"
                  value={selectedLog.entityName}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InfoCard
                  icon={<PersonIcon />}
                  label="Changed By"
                  value={selectedLog.changedBy?.userName || "Unknown"}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InfoCard
                  icon={<EmailIcon />}
                  label="Email"
                  value={selectedLog.changedBy?.userEmail}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InfoCard
                  icon={<AccessTimeIcon />}
                  label="Date & Time"
                  value={convertUTCtoDubai(selectedLog.createdAt)}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <InfoCard
                  icon={<PublicIcon />}
                  label="IP Address"
                  value={selectedLog.metadata?.ipAddress}
                />
              </Grid>

              <Grid item xs={12}>
                <InfoCard
                  icon={<DevicesIcon />}
                  label="User Agent"
                  value={selectedLog.metadata?.userAgent}
                />
              </Grid>

              <Grid item xs={12}>
                <Box
                  sx={{
                    mt: 2,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#ffffff",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      mb: 1.5,
                    }}
                  >
                    Changes
                  </Typography>

                  {renderChangeDetails(selectedLog.changes)}
                </Box>

              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            pt: 1,
            justifyContent: "flex-end",
          }}
        >
          <MDButton
            onClick={handleCloseDetailModal}
            sx={{
              minHeight: 32,
              px: 2.5,
              fontSize: "0.7rem",
              borderRadius: "8px",
              textTransform: "uppercase",
            }}
            variant="gradient"
            color={sidenavColor}
          >
            Close
          </MDButton>
        </DialogActions>

      </Dialog>
    </DashboardLayout>
  );
}

export default AuditLogs;
